<template>
  <div id="app">
    <nav-bar/>
    <candle-pair/>
    <transition name="pentagon-page" mode="out-in" @after-leave="onPageLeft">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import CandlePair from './components/CandlePair.vue';

export default {
  name: 'PentagonApp',
  components: {
    NavBar,
    CandlePair,
  },
  methods: {
    // The page Laravel rendered has left: later pages play their entrance animations again.
    onPageLeft() {
      document.documentElement.classList.remove('pentagon-ssr');
    },
  },
};
</script>
